import React from 'react'
import { Modal, Checkbox, Select } from 'antd'

export default ({ visible, alert_emails=[], logs_emails=[], logs_frequency='Monthly', show_dollar_sign, show_decimal, show_border , on_settings_change,
    on_emails_changes, on_frequency_change, on_save }) => {

    const frequencies =['Daily', 'Weekly', 'Monthly']
    return (
        <Modal visible={visible} className='modal-form finance-settings'
               footer={null} width={467} onCancel={()=> on_save(true)}>

            <header>
                Budget Alerting Email Notifications
            </header>

            <section>
                <header>View Preferences</header>
                <Checkbox name='show_dollar_sign' onChange={on_settings_change}
                          checked={show_dollar_sign}> Show dollar sign </Checkbox>
                <Checkbox name='show_decimal' onChange={on_settings_change}
                          checked={show_decimal}> Show decimal </Checkbox>
                <Checkbox name='show_border' onChange={on_settings_change}
                          checked={show_border}> Show border </Checkbox>
            </section>

            <section>
                <header>Budget Alerts Emails</header>
                <Select
                    mode="tags" open={false}
                    size='large' tokenSeparators={[',', ' ']}
                    placeholder="Please enter email recipients"
                    value={alert_emails}
                    onChange={value => on_emails_changes('alert_emails', value)}
                    style={{width: '100%'}}>
                    {alert_emails.map(e => <Select.Option key={e}>{e}</Select.Option>)}
                </Select>
            </section>

            <section>
                <header>Email Notifications of Audit Logs / Account Changes</header>

                <div className={'container'}>
                    <Select
                        mode="tags" open={false}
                        size='large' tokenSeparators={[',', ' ']}
                        placeholder="Please enter email recipients"
                        value={logs_emails}
                        onChange={value=> on_emails_changes('logs_emails', value)}
                        style={{width: '65%'}}>
                        {alert_emails.map(e => <Select.Option key={e}>{e}</Select.Option>)}
                    </Select>

                    <Select
                        size         = 'large'
                        value        = {logs_frequency}
                        onChange     = {on_frequency_change}
                        style        = {{width: '30%'}}>
                        {frequencies.map(e => <Select.Option key={e}>{e}</Select.Option>)}
                    </Select>
                </div>
            </section>

            <footer>
                <button onClick={()=>on_save()}>Apply</button>
            </footer>
        </Modal>
    )
}